import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import makeSimplePage from './makeSimplePage';
import ActionBtns from './ActionBtns';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';
const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;
// ─────────────────────────────────────────────────────────────────────────────
// 12. STOCK OUT PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const StockOutPage = makeSimplePage({
  title:'Stock Out', subtitle:'Record outgoing stock', Icon:TrendingDown, color:C.danger,
  ctrl:stockOutController, emptyTitle:'No stock-out records',
  statusOptions:['Completed','Pending','Cancelled'],
  defaultForm:{ type:'Sale',warehouseId:'',warehouseName:'',date:new Date().toISOString().split('T')[0],items:[],totalQty:0,totalAmount:0,issuedTo:'',issuedBy:'',status:'Completed',notes:'' },
  columns:(crud,openEdit)=>[
    { label:'Ref No.', key:'referenceNumber', render:v=><span style={{ fontFamily:'monospace', fontSize:12, color:C.danger }}>{v||'—'}</span> },
    { label:'Type', key:'type', render:v=><Badge color={C.danger} bg={`${C.danger}12`}>{v}</Badge> },
    { label:'Warehouse', key:'warehouseName', render:v=>v||'—' },
    { label:'Date', key:'date', render:v=>fmt(v) },
    { label:'Issued To', key:'issuedTo', render:v=>v||'—' },
    { label:'Total Qty', key:'totalQty', render:v=><Badge color={C.danger} bg={`${C.danger}12`}>{v}</Badge> },
    { label:'Total Amount', key:'totalAmount', render:v=>money(v) },
    { label:'Status', key:'status', render:v=><StatusBadge status={v}/> },
    { label:'', key:'actions', render:(_, r)=><ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id,'this stock-out')} /> },
  ],
  formFields:(f,set)=>[
    <FormField key="type" label="Type"><select style={S.select} value={f.type} onChange={e=>set('type',e.target.value)}>{['Sale','Transfer Out','Return','Damage','Adjustment','Other'].map(t=><option key={t}>{t}</option>)}</select></FormField>,
    <FormField key="wn" label="Warehouse Name *"><input style={S.input} value={f.warehouseName} onChange={e=>set('warehouseName',e.target.value)} /></FormField>,
    <FormField key="dt" label="Date *"><input type="date" style={S.input} value={f.date} onChange={e=>set('date',e.target.value)} /></FormField>,
    <FormField key="it" label="Issued To"><input style={S.input} value={f.issuedTo} onChange={e=>set('issuedTo',e.target.value)} /></FormField>,
    <FormField key="ib" label="Issued By"><input style={S.input} value={f.issuedBy} onChange={e=>set('issuedBy',e.target.value)} /></FormField>,
    <FormField key="tq" label="Total Qty"><input type="number" style={S.input} value={f.totalQty} onChange={e=>set('totalQty',e.target.value)} /></FormField>,
    <FormField key="ta" label="Total Amount (₹)"><input type="number" style={S.input} value={f.totalAmount} onChange={e=>set('totalAmount',e.target.value)} /></FormField>,
    <FormField key="st" label="Status"><select style={S.select} value={f.status} onChange={e=>set('status',e.target.value)}>{['Completed','Pending','Cancelled'].map(s=><option key={s}>{s}</option>)}</select></FormField>,
    <FormField key="no" label="Notes" col={2}><textarea style={S.textarea} value={f.notes} onChange={e=>set('notes',e.target.value)} /></FormField>,
  ],
});
export default StockOutPage;